// extracted by mini-css-extract-plugin
export default {"repeatEveryRow":"YgcdXdQCNF"};